import { LayoutContainer, Space } from "@enxcs/dap-ui-stratos";
import styled from "styled-components";

export const CustomLayoutContainer = styled(LayoutContainer)`
  padding-bottom: ${Space.V12} !important;
  padding-top: ${Space.V12} !important;
  display: flex !important;
  flex: 1 1 auto !important;
  min-height: calc(100vh - 104px);
  & > div:first-child {
    gap: 0;
  }
`;
